import React from 'react';
import { Container, Box } from '@mui/material';
import { PageTitleSkeleton } from 'views/common/components';
import { ReviewsSectionsSkeleton } from 'views/information-module/ReviewsView/components/ReviewsSections';

const ReviewsViewSkeleton = () => (
  <Container maxWidth="xl">
    <PageTitleSkeleton />
    <Box mt={3}>
      <ReviewsSectionsSkeleton />
    </Box>
  </Container>
);
export { ReviewsViewSkeleton };
